import { ReactNode } from 'react';
import styled from 'styled-components';
import { TypeBody, TypeHeadingSecondary } from '../../Typography';
import { Container } from 'styled/layouts/container';
import { aligns } from '../product-grid';
import {   mqMediumMin,
  mqLargeMin, mqXXLargeMax } from 'styled/tools/media-queries';
import useClientSideMediaQuery from 'hooks/use-client-side-media-query';

export const ProductHeadline = styled.div<{ align: aligns }>`
  margin-bottom: var(--spacing-40);
  & > * + * {
    margin-top: var(--spacing-24);
  }

  @media ${mqXXLargeMax} {
    padding-inline: var(--spacing-16);

    @media ${mqMediumMin} {
      padding-inline: var(--spacing-24);
    }

    @media ${mqLargeMin} {
      padding-inline: var(--spacing-32);
    }
  }

  & .body {
    max-width: 540px;
  }

  ${(props) =>
    props.align == 'center' &&
    `
    text-align: center;

    & .body {
        margin-inline: auto;
    }
  `}

  ${(props) =>
    props.align == 'left' &&
    `
    max-width: 650px;
  `}
`;

export const ProductCarouselDesktopHeader = styled(Container)`
  padding: 0 var(--spacing-16) var(--spacing-56) var(--spacing-16);
  align-items: end;
  display: flex;
  justify-content: space-between;
  gap: var(--spacing-8);
  padding-inline: var(--spacing-16);
  width: calc(100% - var(--spacing-16) * 2);

  @media ${mqMediumMin} {
    padding-inline: var(--spacing-24);
    width: calc(100% - var(--spacing-24) * 2);
  }

  @media ${mqLargeMin} {
    padding-inline: var(--spacing-32);
    width: calc(100% - var(--spacing-32) * 2);
  }
`;

const TitleContainer = styled.div`
  width: 570px;
`;

const SubtitleContainer = styled.div`
  width: 450px;
`;

interface ProductHeadlineProps {
  title: string;
  body: string;
  textColor: string;
  color: 'seedgreen' | 'snowwhite';
  align: aligns;
  primaryButton?: ReactNode;
}

const ProductHeadlineComponent = ({
  title,
  body,
  textColor,
  align,
  primaryButton,
}: ProductHeadlineProps) => {
  const isSmall = useClientSideMediaQuery(960);
  if (isSmall) {
    return (
      <Container>
        <ProductHeadline align={align}>
          <TypeHeadingSecondary color={textColor}>{title}</TypeHeadingSecondary>
          <TypeBody color={textColor} className='body'>
            {body}
          </TypeBody>
        </ProductHeadline>
      </Container>
    );
  }

  return (
    <ProductCarouselDesktopHeader>
      <TitleContainer>
        <TypeHeadingSecondary color={textColor}>{title}</TypeHeadingSecondary>
      </TitleContainer>
      <SubtitleContainer>
        <TypeBody color={textColor} className='body'>
          {body}
        </TypeBody>
      </SubtitleContainer>
      {primaryButton ? primaryButton : null}
    </ProductCarouselDesktopHeader>
  );
};

export default ProductHeadlineComponent;
